import { Component, Input } from "@angular/core";
import { WorkplaceActivityDto, ActivityTypeInfo } from "../../services/activity.service";

import dataCore = require("../../core/datacore");

@Component({
    selector: "activity-types-display",
    template: require('./activity-types-display.component.html')
})
export class ActivityTypesDisplayComponent {
    activityTypes: ActivityTypeInfo[];

    _workplaceActivities: WorkplaceActivityDto[];

    @Input()
    get workplaceActivities(): WorkplaceActivityDto[] {
        return this._workplaceActivities;
    }

    set workplaceActivities(val) {
        this._workplaceActivities = val;

        if (this._workplaceActivities) {
            const allActivities = dataCore.selectMany(this._workplaceActivities, x => x.Activities);

            this.activityTypes = allActivities.filter((value, index, self) =>
                index === self.findIndex((x) => (
                    x.ActivityTypeId === value.ActivityTypeId
                )))
                .map(x => {
                    const activityType = x.ActivityType;
                    return {
                        ActivityTypeName: activityType.Name,
                        ActivityTypeTimeNorm: activityType.TimeNorm,
                        ActivityTypeColor: activityType.Color
                    };
                })
                .sort((a, b) => (a.ActivityTypeName < b.ActivityTypeName ? -1 : 1));
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/activities/daily-activities/activity-types-display.component.ts